<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsNacionalidade"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsNacionalidade"
          addFilter
          :items="listarEscolaridade"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editNacionalidade"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="nacionalidade.id === 0 ? addNacionalidade() : editandoNacionalidade()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="nacionalidade.id" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="nacionalidade.codnacionalidade" required
              >Código</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="nacionalidade.descricao"
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Nacionalidade',
      titleModal: '',
      titlePDF: 'Nacionalidade',
      listarEscolaridade: [],
      baseUrlGestaoProjetosConcurso: '',
      nacionalidade: [],
      itemPorPage: '100',
      actionsNacionalidade: [
        {
          button: true,
          funcaoButton: 'editNacionalidade',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteNacionalidade',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsNacionalidade: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'codnacionalidade', label: 'Código', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoNacionalidade: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'Nacionalidade/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarEscolaridade = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar Nacionalidade'
      this.nacionalidade = {}
      this.nacionalidade.id = 0
      this.$root.$emit('bv::show::modal', 'editNacionalidade')
    },
    editNacionalidade: function (_, item) {
      this.titleModal = 'Editar Nacionalidade'
      this.nacionalidade = item
      this.$root.$emit('bv::show::modal', 'editNacionalidade')
    },
    editandoNacionalidade: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'Nacionalidade/Alterar',
          this.nacionalidade,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.nacionalidade = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editNacionalidade')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addNacionalidade: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'Nacionalidade/Adicionar',
          this.nacionalidade,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.nacionalidade = {}
          this.listandoNacionalidade()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editNacionalidade')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteNacionalidade: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'Nacionalidade/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoNacionalidade()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoNacionalidade()
  }
}
</script>
